import React from 'react'
import { Waveform } from '@uiball/loaders'

const CustomLoader: React.FC = () => {
  return <Waveform size={60} color='black' />
}

export { CustomLoader }
